import { all, put, takeEvery, call } from 'redux-saga/effects'
import actions from "./actions";
import {getCustomerApi, getCustomersApi, getCustomersToAllocateApi} from "../../services/customers.service";
import { AxiosResponse } from 'axios';
import logError from "../../utils/logError";

export function* GET_CUSTOMERS() {
    try{
      const response: AxiosResponse<any> = yield call(getCustomersApi);
      if(response.data){
          yield put({
              type: actions.SET_CUSTOMERS,
              payload:response.data
          })
      }
    } catch (e) { logError("redux/customers/sagas/GET_CUSTOMERS", e); }
}

export function* GET_CUSTOMER(action: {payload: string, type: string}) {
    try{
        const response: AxiosResponse<any> = yield call(
          getCustomerApi,
          action.payload
        );
        if(response.data){
            yield put({
                type: actions.SET_CUSTOMER,
                payload:response.data
            })
        }
    } catch (e) { logError("redux/customers/sagas/GET_CUSTOMER", e); }
}

export function* GET_CUSTOMERS_TO_ALLOCATE() {
    try{
        const response: AxiosResponse<any> = yield call(
          getCustomersToAllocateApi
        );
        if(response.data){
            yield put({
                type: actions.SET_CUSTOMERS_TO_ALLOCATE,
                payload:response.data
            })
        }
    } catch (e) { logError("redux/customers/sagas/GET_CUSTOMERS_TO_ALLOCATE", e); }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_CUSTOMERS, GET_CUSTOMERS),
        takeEvery(actions.GET_CUSTOMER, GET_CUSTOMER),
        takeEvery(actions.GET_CUSTOMERS_TO_ALLOCATE, GET_CUSTOMERS_TO_ALLOCATE)
    ])
}

